import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const Filter = ({ filterCarrier, setFilterCarrier, setPage, carriers, filterType, setFilterType, selStyle, filterStatus, setFilterStatus, fetchBordereaux }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '12px 32px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.5)',
        flexShrink: 0,
      }}
    >
      <select
        value={filterCarrier}
        onChange={e => {
          setFilterCarrier(e.target.value);
          setPage(1);
        }}
        style={selStyle}
      >
        <option value=''>{t('screens.bordereaux.allCarriers')}</option>
        {carriers.map(c => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
      <select
        value={filterType}
        onChange={e => {
          setFilterType(e.target.value);
          setPage(1);
        }}
        style={selStyle}
      >
        <option value=''>{t('screens.bordereaux.allTypes')}</option>
        <option value='claims'>{t('screens.bordereaux.typeClaims')}</option>
        <option value='premium'>{t('screens.bordereaux.typePremium')}</option>
        <option value='combined'>{t('screens.bordereaux.typeCombined')}</option>
        <option value='loss_run'>{t('screens.bordereaux.typeLossRun')}</option>
        <option value='commission'>{t('screens.bordereaux.typeCommission')}</option>
      </select>
      <select
        value={filterStatus}
        onChange={e => {
          setFilterStatus(e.target.value);
          setPage(1);
        }}
        style={selStyle}
      >
        <option value=''>{t('screens.bordereaux.allStatuses')}</option>
        <option value='generating'>{t('screens.bordereaux.statusGenerating')}</option>
        <option value='ready'>{t('screens.bordereaux.statusReady')}</option>
        <option value='sent'>{t('screens.bordereaux.statusSent')}</option>
        <option value='acknowledged'>{t('screens.bordereaux.statusAcknowledged')}</option>
        <option value='error'>{t('screens.bordereaux.statusError')}</option>
      </select>
      {(filterCarrier || filterType || filterStatus) && (
        <button
          onClick={() => {
            setFilterCarrier('');
            setFilterType('');
            setFilterStatus('');
            setPage(1);
          }}
          style={{ fontSize: 12, color: S.burgundy, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}
        >
          {t('screens.bordereaux.clearFilters')}
        </button>
      )}
      <button
        onClick={fetchBordereaux}
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          padding: '7px 14px',
          background: S.bgCard,
          border: `1px solid ${S.borderLight}`,
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 500,
          color: S.textSecondary,
          cursor: 'pointer',
        }}
      >
        <Icon name='refresh' color={S.textMuted} size={13} /> {t('screens.bordereaux.refresh')}
      </button>
    </div>
  );
};

export default Filter;
